import React from 'react';
import {
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';
import PropTypes from 'prop-types';

import CustomLoginWrapper from './components/presentational/customLogin/customLoginWrapper';

const PortalWrapper = ({ path }) => (
  <Switch>
    <Route path={`${path}/:portalSlug`}>
      <CustomLoginWrapper />
    </Route>
    <Route path={`${path}/*`}>
      <Redirect to='/login' />
    </Route>
  </Switch>
);

PortalWrapper.propTypes = {
  path: PropTypes.string.isRequired,
};

export default PortalWrapper;
